import { Injectable } from '@angular/core';

import { ApiService }                    from '../../api/api.service';
import { DateParserService }             from '../../core/services/date-parser.service';
import { TableQueryParameters }          from '../../table/types/table-query-parameters';
import { TransactionCenterBookingModel } from './typings/transaction-center.booking';
import { TransactionCenterFiltersModel } from '../typings/transaction-center.filters';

@Injectable({
  providedIn: 'root'
})
export class TransactionCenterBookingsService {
  public broadcastKey  = 'filterTransactionCenterBookings';
  public tableCacheKey = 'transactionCenterBookings';

  constructor (
    private apiService       : ApiService,
    private dateParserService: DateParserService
  ) {}

  get ( filters : TransactionCenterFiltersModel = {}, params : TableQueryParameters = {} ) : Promise<Array<TransactionCenterBookingModel>> {
    return this.apiService.get('/transaction_center/bookings', [
        filters.startDate || this.dateParserService.weekRangeStart(null),
        filters.endDate   || this.dateParserService.weekRangeEnd(null),
        filters.value     || '*',
        params.field      || 'event_date',
        params.direction  || 'desc',
        params.pageSize   || 10,
        params.offset     || 0
      ]);
  }

  getCount ( filters : TransactionCenterFiltersModel = {} ) : Promise<number> {
    return this.apiService.get('/transaction_center/bookings_count', [
        filters.startDate || this.dateParserService.weekRangeStart(null),
        filters.endDate   || this.dateParserService.weekRangeEnd(null),
        filters.value     || '*'
      ])
      .then(( count : any ) => count.bookings_count);
  }
}
